import { Link } from "react-router-dom";
import { Mail, PhoneCall, Clock, ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactForm } from "@/components/ContactForm";

const FADE = {
  WebkitMaskImage: "radial-gradient(ellipse at center, #000 62%, transparent 100%)",
  maskImage: "radial-gradient(ellipse at center, #000 62%, transparent 100%)",
};

const INFO = [
  { icon: Mail, label: "EMAIL", color: "text-primary", bg: "bg-sky-100", value: "myskillcity@gmail.com", href: "mailto:myskillcity@gmail.com", text: "Στείλτε μας το μήνυμά σας και θα σας απαντήσουμε άμεσα." },
  { icon: PhoneCall, label: "ΤΗΛΕΦΩΝΟ", color: "text-orange-500", bg: "bg-orange-50", value: "697 418 4597", href: "tel:+306974184597", text: "Μιλήστε απευθείας μαζί μας για οποιαδήποτε πληροφορία." },
  { icon: Clock, label: "ΧΡΟΝΟΣ ΑΠΑΝΤΗΣΗΣ", color: "text-green-600", bg: "bg-green-50", value: "Εντός 1 εργάσιμης ημέρας", text: "Προσπαθούμε να απαντάμε το συντομότερο δυνατό." },
];

const InfoCard = ({ c }) => (
  <div className="flex gap-6 rounded-2xl bg-white shadow-[0_10px_40px_-15px_rgba(15,60,120,0.18)] p-7" data-testid={`contact-info-${c.label}`}>
    <span className={`h-20 w-20 shrink-0 grid place-items-center rounded-2xl ${c.bg} ${c.color}`}><c.icon size={38} strokeWidth={2} /></span>
    <div>
      <p className={`text-[15px] font-bold tracking-wide ${c.color}`}>{c.label}</p>
      {c.href ? <a href={c.href} className="block mt-1 text-xl font-semibold text-slate-900 hover:text-primary transition-colors">{c.value}</a>
        : <p className="mt-1 text-xl font-semibold text-slate-900">{c.value}</p>}
      <p className="mt-2 text-[15px] text-slate-500 leading-relaxed max-w-[260px]">{c.text}</p>
    </div>
  </div>
);

const PartnerBanner = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-10" data-testid="contact-partner-banner">
    <div className="relative rounded-3xl bg-white/70 flex flex-col md:flex-row md:items-center gap-6 pr-6 lg:pr-40 overflow-hidden">
      <img src="/contact/partners.jpg" alt="" style={FADE} className="hidden md:block w-[400px] shrink-0 self-end" />
      <div className="flex-1 px-6 md:px-0 pt-8 md:pt-0">
        <h2 className="font-display text-2xl sm:text-[28px] font-extrabold text-[#0b1442] leading-tight">Θέλετε να προβάλετε τη δραστηριότητά σας<br className="hidden xl:block" /> στο SkillCity;</h2>
        <p className="mt-3 text-slate-500 leading-relaxed">Γίνετε μέρος μιας σύγχρονης πλατφόρμας που βοηθά γονείς, παιδιά και ενήλικες να ανακαλύπτουν δραστηριότητες και υπηρεσίες στην πόλη τους.</p>
      </div>
      <Link to="/partner" data-testid="contact-partner-btn" className="relative z-10 mx-6 md:mx-0 mb-8 md:mb-0 shrink-0 self-start md:self-center inline-flex items-center gap-3 h-14 px-8 rounded-full bg-orange-500 text-white text-lg shadow-lg shadow-orange-500/30 hover:-translate-y-0.5 transition-transform">
        Γίνε συνεργάτης <ArrowRight size={20} />
      </Link>
      <img src="/contact/city_v2.jpg" alt="" style={FADE} className="hidden lg:block absolute right-2 bottom-0 h-[85%] pointer-events-none" />
    </div>
  </section>
);

const ContactPage = () => (
  <div className="min-h-screen bg-[#f5f9fd]" data-testid="contact-page">
    <Navbar />
    <main className="relative overflow-hidden">
      <img src="/contact/envelope_v2.jpg" alt="" style={FADE} className="hidden lg:block absolute left-4 top-0 w-[290px]" />
      <img src="/contact/family_v2.jpg" alt="" style={FADE} className="hidden lg:block absolute right-0 top-0 w-[380px]" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-8">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <p className="text-[15px] font-semibold uppercase tracking-wide text-orange-500">Επικοινωνία</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0b1442]" data-testid="contact-title">Επικοινωνήστε μαζί μας</h1>
          <p className="mt-4 text-lg sm:text-xl text-slate-500 leading-relaxed">Έχετε κάποια ερώτηση ή θέλετε να εντάξετε τη δραστηριότητά σας στο SkillCity; Είμαστε εδώ για να βοηθήσουμε.</p>
        </div>
        <div className="grid lg:grid-cols-[1.25fr_1fr] gap-7 items-start">
          <div className="rounded-2xl bg-white shadow-[0_10px_40px_-15px_rgba(15,60,120,0.18)] p-7 sm:p-8"><ContactForm /></div>
          <div className="space-y-6">{INFO.map((c) => <InfoCard key={c.label} c={c} />)}</div>
        </div>
      </div>
      <PartnerBanner />
      <div className="h-12" />
    </main>
    <Footer legal />
  </div>
);

export default ContactPage;
